import closeIcon from '@/components/Icons/Modals/IconClose.vue';

export default{
	mounted(){
		setTimeout(() => this.modalActive = true, 300);
	},

	data(){
		return{
			modalActive: false,
			changePasswordSuccess: false,

			///////////////
			//// CHANGE PASSWORD
			dChangePassword:{
				password: "",
				newPassword: "",
				newPasswordConfirm: "",
			}  
		}
	},

	
	components:{
		closeIcon,
	},

	methods:{
		closeModal(){

			this.$parent.modal_changePassword = false;
			this.changePasswordSuccess = false;

		},
		changePassword(scope){
			this.$validator.validateAll(scope).then((result) => {
				if (result) {
					(async () => {
						this.dChangePassword.email = this.$session.get('email');
						var rawResponse = await fetch('https://sandbox.api.salonacme.com/manager/change_password', {
							method: 'PUT',
							headers: {
								'Accept': 'application/json',
								'Content-Type': 'application/json'
							},
							body: JSON.stringify({
								_id: this.$session.get('_id'),
								data: this.dChangePassword
							})
						});
						const content = await rawResponse.json();
						if(content.status){
							this.changePasswordSuccess = true;
							this.dChangePassword.password = "";
							this.dChangePassword.newPassword = "";
							this.dChangePassword.newPasswordConfirm = "";
						}
						else
							alert(content.msg);
					})();
				}
			});

		}
	}
}